import { InjectionToken } from '@angular/core';

export class AppConfig {
  signUpUrl: string | undefined;
  shopHost: string | undefined;
  featureHeroAllowedEnterprises: string[] | undefined;
  googleReCaptchaSiteKey: string | undefined;
  masterCardResetPasswordUrl: string | undefined;
  launchDarklyEnvKey: string | undefined;
}

export const WINDOW = new InjectionToken<AppWindow>('Window object', {
  providedIn: 'root',
  factory: () => window as unknown as AppWindow,
});

export class AppWindow extends Window {
  portalConfig!: AppConfig;
}

export interface LocalStorage {
  getItem: (key: string) => string | null;

  setItem(key: string, value: string): void;
}

export const appWindow: AppWindow = window as unknown as AppWindow;
